import { SuperAdminService } from "services/superAdminService";

class AiportsSAService extends SuperAdminService<any> {
  constructor() {
    super("airports");
  }
}
export default new AiportsSAService();
